// import React, { useState } from "react";
// import { H1, PL } from "@components/ui/typography";
// import Button from "@components/ui/button";
// import Section from "@layouts/section";
// import TextLabel from "@components/ui/text-label";
// import { StaticImage } from "gatsby-plugin-image";
// import SideBar from "@components/ui/sidebar";
// import { useForm, SubmitHandler } from "react-hook-form";
// import Input from "../../ui/input";

// interface MigratePhpToRailsGuideProps extends React.HTMLProps<HTMLDivElement> {}

// const MigratePhpToRailsGuide: React.FC<MigratePhpToRailsGuideProps> = () => {
//   type Inputs = object;
//   interface IFormInput {
//     name: string;
//     email: string;
//     phone: string;
//     company: string;
//     message: string;
//   }
//   const {
//     handleSubmit,
//     register,
//     formState: { errors }
//   } = useForm<IFormInput>();
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   const onSubmit: SubmitHandler<Inputs> = (data: any) => {
//     const formData = new FormData();
//     formData.append("First Name", data.name);
//     formData.append("Email", data.email);
//     formData.append("company", data.company);
//   };

//   const [isSideBarOpen, setSideBarOpen] = useState(false);
//   const openSidebar = () => setSideBarOpen(!isSideBarOpen);
//   return (
//     <Section>
//       <div className="bg-dark text-emerald-50 rounded-2xl md:rounded-4xl px-6 py-16 md:py-32">
//         <div className="flex flex-col-reverse md:flex-row max-w-5xl mx-auto">
//           <div className="md:w-1/2 mt-8 md:mt-0">
//             <TextLabel variant="light">Free guide</TextLabel>
//             <H1 className="mt-6">How to Migrate Your PHP App to Rails</H1>
//             <PL className="mt-8">
//               Thinking on moving your PHP app to Rails? This guide is crafted for developers, tech
//               leads, and CTOs looking to make a successful transition from PHP to Ruby on Rails.
//             </PL>
//             <Button
//               variant="outline-dark"
//               size="lg"
//               className="inline-block mt-12"
//               onClick={openSidebar}
//             >
//               Download my guide
//             </Button>
//           </div>
//           <SideBar
//             title="Download your guide"
//             open={isSideBarOpen}
//             closeModal={() => setSideBarOpen(false)}
//           >
//             <PL>
//               Get your free guide now! Just fill in your details below for immediate access to
//               essential insights.
//             </PL>
//             <form onSubmit={handleSubmit(onSubmit)}>
//               <div className="mt-6">
//                 <Input
//                   // label="Full Name"
//                   register={register}
//                   name="name"
//                   placeholder="Full Name"
//                   required
//                   errors={errors?.name} // Pass the specific error for this field
//                 />
//               </div>
//               <div className="mt-6">
//                 <Input
//                   type="email"
//                   name="email"
//                   placeholder="Email"
//                   register={register}
//                   required
//                   validationOptions={{
//                     pattern: {
//                       value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
//                       message: "Invalid email address"
//                     }
//                   }}
//                   errors={errors.email} // Pass the specific error for this field
//                 />
//               </div>
//               <div className="mt-6">
//                 <Input
//                   type="text"
//                   name="company"
//                   placeholder="Company name"
//                   register={register}
//                   required
//                   errors={errors.company} // Pass the specific error for this field
//                 />
//               </div>
//               <div className="mt-6">
//                 <Button type="submit" size="lg">
//                   Download now
//                 </Button>
//               </div>
//             </form>
//           </SideBar>
//           <div className="flex justify-center md:w-1/2 md:justify-end">
//             <StaticImage
//               src="../../../images/migrate-php-to-rails-guide.png"
//               alt="Image of a PDF guide mockup"
//             />
//           </div>
//         </div>
//       </div>
//     </Section>
//   );
// };

export default () => null;
